// @ts-nocheck
import React from 'react'
import cx from 'classnames'

import styles from './Arrow.module.scss'

export const Arrow = React.forwardRef(
  ({ className = undefined, size, style, theme }, ref) => (
    <svg
      className={cx(styles.arrow, {
        [styles.size]: Boolean(size),
        [styles[size]]: Boolean(size),
        [styles.theme]: Boolean(theme),
        [styles[theme]]: Boolean(theme),
        [className]: Boolean(className),
      })}
      viewBox="0 2 14 12"
      {...{ ref, style }}
    >
      <path d="m0 14 5-8q2-3 4 0l5 8" />
    </svg>
  ),
)
